import {ChangeDetectionStrategy, Component, EventEmitter, Output} from '@angular/core';

@Component({
    selector: 'app-quote-view-selection',
    templateUrl: './quote-view-selection.component.html',
    styleUrls: ['./quote-view-selection.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuoteViewSelectionComponent {

    @Output()
    close = new EventEmitter();

    @Output()
    openCreateQuote = new EventEmitter();

    @Output()
    openQuotesList = new EventEmitter();

    @Output()
    openSubmittedQuotesList = new EventEmitter();

    constructor() {
    }

    onOpenCreateQuote() {
        this.openCreateQuote.emit();
    }

    onOpenQuotesList() {
        this.openQuotesList.emit();
    }

    onCloseMenu() {
        this.close.emit();
    }

    onOpenSubmittedQuotesList() {
        this.openSubmittedQuotesList.emit();
    }
}
